import { render, staticRenderFns } from "./ProjectDatesRibbon.vue?vue&type=template&id=3d67d60f&"
import script from "./ProjectDatesRibbon.vue?vue&type=script&lang=js&"
export * from "./ProjectDatesRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d67d60f')) {
      api.createRecord('3d67d60f', component.options)
    } else {
      api.reload('3d67d60f', component.options)
    }
    module.hot.accept("./ProjectDatesRibbon.vue?vue&type=template&id=3d67d60f&", function () {
      api.rerender('3d67d60f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectDatesRibbon.vue"
export default component.exports